import { AfterViewInit, Component, OnDestroy, OnInit } from '@angular/core';
import { AlliancesService } from '@core/services/alliances.service';
import { AnalyticsService } from '@core/services/analytics.service';
import { Store } from '@ngrx/store';
import { UrlService } from '@services/url.service';
import { IHotelsAppState } from '@store/index';

import { ResultsBaseComponent } from './../base/results-base.component';

@Component({
  selector: 'am-app-results',
  styleUrls: ['./results.component.scss'],
  templateUrl: './results.component.html',
})
export class ResultsComponent extends ResultsBaseComponent
  implements OnInit, OnDestroy, AfterViewInit {
  constructor(
    protected store$: Store<IHotelsAppState>,
    protected allianceService: AlliancesService,
    protected analyticsService: AnalyticsService,
    protected urlService: UrlService,
  ) {
    super(store$, allianceService, analyticsService, urlService);
  }

  public ngAfterViewInit() {
    this.viewInit = true;
  }
}
